//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "ESRS",
  data() {
    return {
      form: {
        age:"",
        // ageSmall: "0",
        // ageMiddle: "0",
        // ageOver75: "0",
        hypertension: "0",
        diabetes: "0",
        myocardial: "0",
        cardiovascular: "0",
        peripheral : "0",
        smoke:'0',
        tia:'0',
        arteriosclerosis:'0',
        neurological:'0',
        neurologicalQuel:'0'
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "< 65岁 " },
        { value: "1", name: "65-75岁" },
        { value: "2", name: ">75岁 " },
      ],

    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      console.log(form,'form1');
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      console.log(form,'form');
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // diabetes + hypertension + ageOver60 + clinic + duration  + (dual ? 2 : 0) + (mri ? 2 : 0) + (stenosis ? 2 : 0)
        let result =
          form.age +
          form.hypertension +
          form.diabetes +
          form.myocardial +
          form.cardiovascular +
          form.peripheral +
          form.smoke +
          form.tia + form.arteriosclerosis + form.neurological + form.neurologicalQuel
          ;

        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/ESRS.vue